import React from "react";

import { AttributeCardDisplayVariantType } from "../types";

import AttributeSelectionCard from "@/Components/PersonalAttributes/Components/AttributeSelectionCard";
import { type AppUserSession } from "@/schemas/auth/session";
import {
  RelationshipStatus,
  UserRelationshipAttributeSet,
} from "@/schemas/profile/attributes/UserRelationshipAttributeSet";
import type { AttributeValue } from "@/schemas/attribute/AttributeSet";

type RelationshipProps = {
  session: AppUserSession;
  status: RelationshipStatus | null;
  variant: AttributeCardDisplayVariantType;
};

function RelationshipSelection({
  session,
  status,
  variant,
}: RelationshipProps): React.JSX.Element {
  const values = status ? [UserRelationshipAttributeSet.map[status]] : [];
  const typedValues = values.filter(
    (item): item is AttributeValue => item !== undefined,
  );

  return (
    <AttributeSelectionCard
      session={session}
      attribute={UserRelationshipAttributeSet}
      values={typedValues}
      icon={"👥"}
      variant={variant}
      fullWidth={variant === AttributeCardDisplayVariantType.ONBOARDING}
    />
  );
}

export default RelationshipSelection;
